import React from "react";
import Hero from "./Hero";

const Header = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default Header;
